import AvatarUpload from './AvatarUpload';

export default AvatarUpload;
